__webpack_require__.p = "/magick-wasm/magick-wasm-docs/";